import theme from '../../../../../lib/theme';

const {
  layouts,
  scale,
  media,
  font: { families, heights, spacings },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    alignItems: 'center',
    padding: `${scale.s} ${scale.xs}`,

    '> div': {
      flexDirection: 'row',
      gap: '1rem',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },

  blockItem: {
    display: 'flex',
    flex: '1 0 30%',
    maxWidth: '30%',
    margin: 0,

    [media.l.down]: {
      flex: '1 0 48%',
      maxWidth: '48%',
    },

    [media.s.down]: {
      flex: '1 0 100%',
      maxWidth: '100%',
    },
  },
});
